/* eslint-disable */
import React from 'react';

const SeperatorIcon = () => (
    <svg width="3" height="12" viewBox="0 0 3 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="1.5" y1="-4.37114e-08" x2="1.5" y2="12" stroke="#CDCDCD" stroke-width="2" />
    </svg>
);

export default SeperatorIcon;